module.exports = __webpack_public_path__ + "static/img/img-about-9.e3c52be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-9.png
// module id = 2+vH
// module chunks = 0